export default __webpack_public_path__ + "static/timik-11e6124f79add56f2d98ec72a48ff3ce.png";